import DriverContractsDriversListRequest from "../../../../api/raily/driver/contracts/drivers-list/driver-contracts-drivers-list.request";
import DriverContractsDriversListParams from "./driver-contracts-drivers-list-params";

const create = (
  params: DriverContractsDriversListParams,
): DriverContractsDriversListRequest => {
  return {
    driverUuid: params.driverUuid,
  };
};

const driverContractsDriversListParamsFactory = {
  create,
};

export default driverContractsDriversListParamsFactory;
